/*
@function calculateSqfeetScore
@param {Object} listing
@param {Number} filterValue
*/
function calculateSqfeetScore(listing, filterValue) {
    var sqfeet = listing.home_size;
    var percent = Math.abs(Math.round(sqfeet / filterValue * 100) - 100);
    var weight = 1;
    var value = 0;
    var threshold = 8;

    if(0 <= percent && percent <= 10) {
        value = 10;
    } else if(10 < percent && percent <= 15) {
        value = 9;
    } else if(15 < percent && percent <= 20) {
        value = 8;
    } else if(20 < percent && percent <= 25) {
        value = 7;
    } else if(25 < percent && percent <= 30) {
        value = 6;
    } else if(30 < percent && percent <= 35) {
        value = 5;
    } else if(35 < percent && percent <= 40) {
        value = 4;
    } else if(40 < percent && percent <= 45) {
        value = 3;
    } else if(45 < percent && percent <= 50) {
        value = 2;
    } else if(50 < percent && percent <= 55) {
        value = 1;
    } else if(55 < percent && percent <= 60) {
        value = 0;
    } else if(60 < percent && percent <= 65) {
        value = -1;
    } else if(65 < percent && percent <= 70) {
        value = -2;
    } else if(70 < percent && percent <= 75) {
        value = -3;
    } else if(75 < percent && percent <= 80) {
        value = -4;
    } else if(80 < percent && percent <= 85) {
        value = -5;
    } else if(85 < percent && percent <= 90) {
        value = -6;
    } else if(90 < percent && percent <= 95) {
        value = -7;
    }  else if(95 < percent && percent <= 100) {
        value = -8;
    } else {
        value = -10;
    }

    return {
        weight: weight,
        value: value,
        score: value * weight,
        metThreshold: (value * weight) >= threshold,
        metWhyWhyNotThreshold: (value * weight) >= threshold
    };
}

module.exports = calculateSqfeetScore;
